import { UsdValue } from 'components/UsdValue';
import { Tiny1 } from 'components/Typography';
import { toNumber } from 'lodash';
import { twMerge } from 'tailwind-merge';
import { formatValueToSixDecimals } from '@dapp/multi-lib/lib/formatters';
import { getVaultPerformanceColorClass } from 'structure/pv2/dynavault/utils/vaultPerformance';

interface VaultPriceProps {
  price: number;
  size?: 'xsmall' | 'small';
  performance: string;
  showPerformance?: boolean;
  className?: string;
  format?: Intl.NumberFormatOptions;
}

export const VaultPrice = (props: VaultPriceProps) => {
  const {
    price,
    performance,
    showPerformance,
    size = 'small',
    className,
    format = { minimumFractionDigits: 2, maximumFractionDigits: 6 },
  } = props;

  const performanceValue = toNumber(performance.replace('%', ''));

  return (
    <div className={twMerge('flex flex-col items-end', className)}>
      <UsdValue size={size} value={price} format={format} />
      {showPerformance && (
        <Tiny1
          className={twMerge(
            'font-normal',
            getVaultPerformanceColorClass(performanceValue)
          )}
        >
          {formatValueToSixDecimals(performanceValue)}%
        </Tiny1>
      )}
    </div>
  );
};
